var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { StakeProgram, SystemProgram, SYSVAR_CLOCK_PUBKEY, SYSVAR_STAKE_HISTORY_PUBKEY, } from "@solana/web3.js";
import { findBSolTokenAccountAuthority, findGSolMintAuthority, } from "./util.js";
import { STAKE_POOL_PROGRAM_ID } from "./constants.js";
import { utils } from "@coral-xyz/anchor";
import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { MarinadeUtils, Provider, } from "@sunrisestake/marinade-ts-sdk";
export var blazeDeposit = function (config, program, blaze, depositor, depositorGsolTokenAccount, lamports) { return __awaiter(void 0, void 0, void 0, function () {
    var gsolMintAuthority, bsolTokenAccountAuthority, bsolAssociatedTokenAddress, accounts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gsolMintAuthority = findGSolMintAuthority(config)[0];
                bsolTokenAccountAuthority = findBSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: blaze.bsolMint,
                        owner: bsolTokenAccountAuthority,
                    })];
            case 1:
                bsolAssociatedTokenAddress = _a.sent();
                accounts = {
                    state: config.stateAddress,
                    gsolMint: config.gsolMint,
                    gsolMintAuthority: gsolMintAuthority,
                    depositor: depositor,
                    depositorGsolTokenAccount: depositorGsolTokenAccount,
                    bsolTokenAccount: bsolAssociatedTokenAddress,
                    bsolAccountAuthority: bsolTokenAccountAuthority,
                    stakePool: blaze.pool,
                    stakePoolWithdrawAuthority: blaze.withdrawAuthority,
                    reserveStakeAccount: blaze.reserveAccount,
                    managerFeeAccount: blaze.feesDepot,
                    stakePoolTokenMint: blaze.bsolMint,
                    stakePoolProgram: STAKE_POOL_PROGRAM_ID,
                    systemProgram: SystemProgram.programId,
                    tokenProgram: TOKEN_PROGRAM_ID,
                };
                return [2 /*return*/, program.methods
                        .splDepositSol(lamports)
                        .accounts(accounts)
                        .transaction()];
        }
    });
}); };
export var blazeDepositStake = function (config, program, provider, blaze, depositor, stakeAccount, depositorGsolTokenAccount) { return __awaiter(void 0, void 0, void 0, function () {
    var gsolMintAuthority, bsolTokenAccountAuthority, bsolAssociatedTokenAddress, newProvider, stakeAccountInfo, validatorAccount, accounts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gsolMintAuthority = findGSolMintAuthority(config)[0];
                bsolTokenAccountAuthority = findBSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: blaze.bsolMint,
                        owner: bsolTokenAccountAuthority,
                    })];
            case 1:
                bsolAssociatedTokenAddress = _a.sent();
                newProvider = new Provider(provider.connection, provider.wallet, {});
                return [4 /*yield*/, MarinadeUtils.getParsedStakeAccountInfo(newProvider, stakeAccount)];
            case 2:
                stakeAccountInfo = _a.sent();
                validatorAccount = stakeAccountInfo.voterAddress;
                if (!validatorAccount) {
                    throw new Error("Invalid validator account");
                }
                accounts = {
                    state: config.stateAddress,
                    gsolMint: config.gsolMint,
                    gsolMintAuthority: gsolMintAuthority,
                    stakeAccountDepositor: depositor,
                    stakeAccount: stakeAccount,
                    depositorGsolTokenAccount: depositorGsolTokenAccount,
                    bsolTokenAccount: bsolAssociatedTokenAddress,
                    bsolAccountAuthority: bsolTokenAccountAuthority,
                    stakePool: blaze.pool,
                    validatorList: blaze.validatorList,
                    stakePoolDepositAuthority: blaze.depositAuthority,
                    stakePoolWithdrawAuthority: blaze.withdrawAuthority,
                    validatorStakeAccount: validatorAccount,
                    reserveStakeAccount: blaze.reserveAccount,
                    managerFeeAccount: blaze.feesDepot,
                    stakePoolTokenMint: blaze.bsolMint,
                    sysvarStakeHistory: SYSVAR_STAKE_HISTORY_PUBKEY,
                    sysvarClock: SYSVAR_CLOCK_PUBKEY,
                    nativeStakeProgram: StakeProgram.programId,
                    stakePoolProgram: STAKE_POOL_PROGRAM_ID,
                    tokenProgram: TOKEN_PROGRAM_ID,
                };
                return [2 /*return*/, program.methods.splDepositStake().accounts(accounts).transaction()];
        }
    });
}); };
export var blazeWithdrawSol = function (config, program, blaze, user, userGsolTokenAccount, amount) { return __awaiter(void 0, void 0, void 0, function () {
    var bsolTokenAccountAuthority, bsolAssociatedTokenAddress, accounts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bsolTokenAccountAuthority = findBSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: blaze.bsolMint,
                        owner: bsolTokenAccountAuthority,
                    })];
            case 1:
                bsolAssociatedTokenAddress = _a.sent();
                accounts = {
                    state: config.stateAddress,
                    gsolMint: config.gsolMint,
                    user: user,
                    userGsolTokenAccount: userGsolTokenAccount,
                    bsolTokenAccount: bsolAssociatedTokenAddress,
                    bsolAccountAuthority: bsolTokenAccountAuthority,
                    stakePool: blaze.pool,
                    stakePoolWithdrawAuthority: blaze.withdrawAuthority,
                    reserveStakeAccount: blaze.reserveAccount,
                    managerFeeAccount: blaze.feesDepot,
                    stakePoolTokenMint: blaze.bsolMint,
                    sysvarStakeHistory: SYSVAR_STAKE_HISTORY_PUBKEY,
                    sysvarClock: SYSVAR_CLOCK_PUBKEY,
                    nativeStakeProgram: StakeProgram.programId,
                    stakePoolProgram: STAKE_POOL_PROGRAM_ID,
                    tokenProgram: TOKEN_PROGRAM_ID,
                };
                return [2 /*return*/, program.methods
                        .splWithdrawSol(amount)
                        .accounts(accounts)
                        .transaction()];
        }
    });
}); };
export var blazeWithdrawStake = function (config, program, blaze, newStakeAccount, user, userGsolTokenAccount, amount) { return __awaiter(void 0, void 0, void 0, function () {
    var bsolTokenAccountAuthority, bsolAssociatedTokenAddress, accounts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                bsolTokenAccountAuthority = findBSolTokenAccountAuthority(config)[0];
                return [4 /*yield*/, utils.token.associatedAddress({
                        mint: blaze.bsolMint,
                        owner: bsolTokenAccountAuthority,
                    })];
            case 1:
                bsolAssociatedTokenAddress = _a.sent();
                accounts = {
                    state: config.stateAddress,
                    gsolMint: config.gsolMint,
                    user: user,
                    userGsolTokenAccount: userGsolTokenAccount,
                    userNewStakeAccount: newStakeAccount,
                    bsolTokenAccount: bsolAssociatedTokenAddress,
                    bsolAccountAuthority: bsolTokenAccountAuthority,
                    stakePool: blaze.pool,
                    validatorStakeList: blaze.validatorList,
                    stakePoolWithdrawAuthority: blaze.withdrawAuthority,
                    stakeAccountToSplit: blaze.reserveAccount,
                    managerFeeAccount: blaze.feesDepot,
                    stakePoolTokenMint: blaze.bsolMint,
                    sysvarClock: SYSVAR_CLOCK_PUBKEY,
                    nativeStakeProgram: StakeProgram.programId,
                    stakePoolProgram: STAKE_POOL_PROGRAM_ID,
                    tokenProgram: TOKEN_PROGRAM_ID,
                };
                return [2 /*return*/, program.methods
                        .splWithdrawStake(amount)
                        .accounts(accounts)
                        .transaction()];
        }
    });
}); };
//# sourceMappingURL=../../src/dist/blaze.js.map